ACC.saveorder = {/* eslint-disable xss/no-mixed-html *//* eslint-disable vars-on-top */

  bindToAddToSaveForm: function() {
    $('#mergebtn')
      .click(function() {
        var listname = $('#listName').val();

        $
          .ajax({
            url: '/philipsb2bstorefront/nlatam/en/USD/mergeList',
            data: {
              listName: listname
            },
            type: 'POST',
            datatype: 'json',
            success: function(result) {
              var obj = $.parseJSON(JSON
                .stringify(result));

              // Alert(obj.addToFavoriteList);
              /* eslint-disable no-undef */
              /* eslint-disable no-undefined */
              if (obj.addToFavoriteList !== undefined) {
              /* eslint-enable no-undefined */
                $('.white_content_merge')
                  .hide();
                $('.white_content')
                  .html('<spring:escapeBody javaScriptEscape="true"><div class="title"><h4-saveOrder>' +
                      ACC.ordersavedtext +
                      '</h4-saveOrder>' +
                      '<a href="#" class="close" id="add_to_save_close"></a>' +
                      '</div>   <div class="cart_modal_popup"><div class="cart_popup_error_msg"><spring:theme code="error" /></div>' +
                      ' <div class="prod_info"> <p>' +
                      ACC.withnametext +
                      '<b> ' +
                      obj.orderName +
                      '</b></p>  </div>  </div></spring:escapeBody>');
                $('.white_content').show();

                setTimeout(function() {
                  $('.white_content')
                    .fadeOut();
                }, 5000);
              }
            },
            error: function() {
              $('#mergebtn').html('');
            }

          });
      });

    $('#SaveOrderButton')
      .click(function() {
        var listname = $.trim($('#myFavListName').val());

        if (listname !== '' && listname !== null) {
          $
            .ajax({
              url: ACC.config.encodedContextPath +
                  '/addToFavList',
              data: {
                favListName: listname
              },
              type: 'POST',
              datatype: 'json',
              success: function(result) {
                var obj = $.parseJSON(JSON
                  .stringify(result));

                // Alert(obj.addToFavoriteList);
                /* eslint-disable no-undefined */
                /* eslint-disable no-negated-condition */
                if (obj.addToFavoriteList !== undefined) {
                  /* eslint-enable no-negated-condition*/
                /* eslint-enable no-undefined */
                  $('.white_content_merge')
                    .hide();
                  $('.white_content')
                    .html('<spring:escapeBody javaScriptEscape="true"><div class="title">  <h4-saveOrder>' +
                        ACC.ordersavedtext +
                        '</h4-saveOrder>' +
                        '<a href="#" class="close" id="add_to_save_close"></a>' +
                        '  </div>      <div class="cart_modal_popup"><div class="cart_popup_error_msg"><spring:theme code="error" /></div>' +
                        '  <div class="prod_info">  <p>' +
                        ACC.withnametext +
                        '<b> ' +
                        obj.orderName +
                        '</b></p>    </div>  </div></spring:escapeBody>');
                  $('.white_content').show();
                  $('#save_popup').hide();
                  setTimeout(function() {
                    $('.white_content')
                      .fadeOut();
                  }, 5000);
                } else {
                  $('#listName').val(obj.orderName);
                  $('.white_content').hide();
                  $('.white_content_merge')
                    .show();
                  $('#save_popup').hide();
                }
              },
              error: function() {
                $('#save_popup').hide();
              }

            });
        }

        var $AddToSaveForm = $('.add_to_save_form');

        $AddToSaveForm.ajaxForm({
          success: ACC.saveorder.displayAddToSavePopup
        });
      });
  },

  displayAddToSavePopup: function(cartResult) {
    $('#cart_popup').hide();
    $('#save_popup').hide();

    $('#save_popup').html(cartResult.cartPopupHtml);
    /* eslint-disable id-length */
    $('#add_to_save_close').click(function(e) {
      e.preventDefault();
      $('#save_popup').hide();
    });/* eslint-enable id-length */

    var $AddToMergeForm = $('.add_to_merge_form');

    $AddToMergeForm.ajaxForm({
      success: ACC.saveorder.displayAddToSavePopup
    });

    $('#save_popup').fadeIn();

    var timeoutId = setTimeout(function() {
      $('#save_popup').fadeOut();
    }, 50000);

    if (typeof timeoutId !== 'undefined') {
      clearTimeout();
    }

    $.colorbox.close();
  }

};

/* ###############################For Save Order
   JS###################################// */

$('.save-order-popup').click(function() {
  $('#save_popup').show();
});

$('#cboxClose').click(function() {
  $('#save_popup').hide();
});

$('#reset_save_order').click(function() {
  $('#save_popup').hide();
});

$(document).ready(function() {
  function createUserEventObj(url, desc, trigger, compname) {
    return {
      url: url,
      description: desc,
      trigger: trigger,
      compname: compname
    };
  }

  /* eslint-disable no-with */
  with (ACC.saveorder) {
    bindToAddToSaveForm();
    /* eslint-enable no-with */
    /* eslint-enable no-undef */
  }

  $('#closepop').on('click', function() {
    $('#save_popup').hide();
  });

  $(document).on('click', '.ph-returnorder__button', function() {
    var orderCode = $('#ph-ordercode').val(),
        urlLink = ACC.config.encodedContextPath + '/returnOrder/process/' + orderCode,
        trigger = 'linkCategory.clickReturnOrder',
        compname = 'linkReturnOrder',
        desc = 'Return Order ' + orderCode,
        userEventObj = '';

    userEventObj = createUserEventObj(urlLink, desc, trigger, compname);
    ACC.googleanalytics.gaEventsForLinks(userEventObj);
  });

  $(document).on('click', '#ph-returnorder__yes', function() {
    var orderCode = $('#orderCode').val(),
        urlLink = ACC.config.encodedContextPath + '/my-account/order/' + orderCode,
        trigger = 'linkCategory.clickReturnOrderConfirmation',
        compname = 'linkReturnOrderConfirmation',
        desc = 'Return Order Confirmation ' + orderCode,
        userEventObj = '';

    userEventObj = createUserEventObj(urlLink, desc, trigger, compname);
    ACC.googleanalytics.gaEventsForLinks(userEventObj);
  });

  $(document).on('click', '.ph-cancel_order', function() {
    $.colorbox({
      width: '500px',
      maxWidth: '90%',
      height: '180px',
      html: $('.ph-CancelPopup').html(),
      overlayClose: false,
      closeButton: true,
      onClosed: function() {
        ACC.common.refreshScreenReaderBuffer();
      }
    });
  });

  $(document).on('click', '#ph-cancelorder__yes', function() {
    var orderCode = $('#ph-ordercode').val();

    $(this).addClass('ph-disable-button');
    $('.ph-returnorder__no').addClass('ph-disable-button');

    $.ajax({
      url: ACC.config.encodedContextPath + '/cancel/order/' + orderCode,
      data: {
        orderCode: orderCode
      },
      type: 'POST',
      datatype: 'json',
      success: function(result) {
        if (result === 'Success') {
          $.colorbox({
            width: '450px',
            maxWidth: '90%',
            height: '180px',
            html: $('.ph-cancel_orderconf').html(),
            overlayClose: false,
            onComplete: function() {
              ACC.common.refreshScreenReaderBuffer();
            },
            onClosed: function() {
              ACC.common.refreshScreenReaderBuffer();
            }
          });
        } else if (result === 'Failure') {
          $.colorbox({
            width: '450px',
            maxWidth: '90%',
            height: '180px',
            html: $('.ph-cancel_ordererror').html(),
            overlayClose: false,
            onComplete: function() {
              ACC.common.refreshScreenReaderBuffer();
            },
            onClosed: function() {
              ACC.common.refreshScreenReaderBuffer();
            }
          });
        }
      },
      error: function() {
        ACC.common.refreshScreenReaderBuffer();
      }
    });
  });
});/* eslint-enable xss/no-mixed-html *//* eslint-enable vars-on-top */
